module.exports = "https://portperrypedals.ca/_res/img/elexicon.b15bd95.png";